import { request } from './client';
import type { AccountProfile, AccountSessionInfo, CompanyRequisites } from '@kassa/shared';

// Hesabım (KT-42): öz profil və Google bağlantısı
export const accountApi = {
  accountProfile: () => request<AccountProfile>('GET', '/api/account'),
  googleUnlink: () => request<void>('POST', '/api/auth/google/unlink'),
  passwordInit: (password: string) => request<void>('POST', '/api/account/password-init', { password }),
  emailVerifySend: () => request<{ sent: boolean }>('POST', '/api/account/email/verify-send'),
  // Açıq sessiyalar (KT-94)
  accountSessions: () => request<AccountSessionInfo[]>('GET', '/api/account/sessions'),
  accountSessionClose: (id: string) => request<void>('DELETE', `/api/account/sessions/${encodeURIComponent(id)}`),
  accountSessionsCloseOthers: () => request<{ closed: number }>('POST', '/api/account/sessions/close-others'),
  // Şirkət rekvizitləri (KT-95)
  companyRequisites: () => request<CompanyRequisites>('GET', '/api/settings/company'),
  companyRequisitesSave: (body: CompanyRequisites) => request<CompanyRequisites>('PUT', '/api/settings/company', body),
};
